import { MainLayoutWrapper, Main, Img, MainForm } from './styles';
import { Skeleton } from './SkeletonLayout';

const MainLayout = ({ children, skeleton }) => {
  return (
    <MainLayoutWrapper>
      <Skeleton show={skeleton} />
      <Main>
        <Img />
        <MainForm data-testid="main-form">{children}</MainForm>
      </Main>
    </MainLayoutWrapper>
  );
};

export { MainLayout };
